export default function CTASection() {
  return (
    <section className="relative py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/39543f49c434f3c36f9bc12749327d4d.jpg"
          alt="Highway at Sunset"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-7xl font-bold text-white mb-6">
          READY TO SHIP?
        </h2>
        <p className="text-xl text-white/90 mb-10 leading-relaxed">
          Get your quote today and experience<br />
          logistics without boundaries
        </p>
        <a 
          href="tel:+13173972529"
          className="inline-flex items-center gap-4 px-8 py-4 bg-[#3D2817] text-white rounded-full hover:bg-[#E67E50] transition-all cursor-pointer whitespace-nowrap group"
        >
          <div className="w-10 h-10 rounded-full bg-[#F5A962] flex items-center justify-center">
            <i className="ri-phone-line text-lg text-white"></i>
          </div>
          <span className="text-sm font-semibold uppercase tracking-wider">Get Started</span>
          <i className="ri-arrow-right-up-line text-xl group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"></i>
        </a>
      </div>
    </section>
  );
}
